import { roleIsAllowed } from "./roleIsAllowed";

interface Props {
  authorizedComponent: any;
  unauthorizedComponent?: any;
  userRoles: Array<string> | undefined;
  authorizedRoles: Array<string>;
}

export function RoleAuthorized({
  userRoles = [],
  authorizedComponent,
  unauthorizedComponent,
  authorizedRoles,
}: Props) {
  return (
    <>
      {roleIsAllowed(userRoles, authorizedRoles)
        ? authorizedComponent
        : unauthorizedComponent || null}
    </>
  );
}
